<template>
  <div :class="['c-toasts__item', 'c-toasts__item--' + toast.type, hasEvents]" @click="handleClick">
    <svg v-if="typeIcon" :class="['icon', typeIcon]"><use :xlink:href="'#' + typeIcon"></use></svg>
    <span class="c-toasts__item-text">{{ toast.text }}</span>
  </div>
</template>

<script>
  export default {
    name: 'Toast',
    
    props: {
      toast: {
        type: Object,
        required: true
      }
    },

    computed: {
      typeIcon () {
        switch (this.toast.type) {
          case 'success': 
            return 'icon-confirm';
          break;

          case 'danger': 
            return 'icon-cancel';
          break;

          case 'warning': 
            return 'icon-notifications';
          break;

          default: 
            return null;
          break;
        }
      },

      hasEvents () {
        return this.toast.action ? 'c-toasts__item--has-events' : null; 
      }
    },

    methods: {
      handleClick () {
        if (!this.toast.action) return;

        this.toast.action();
      }
    }
  };
</script>


// WEBPACK FOOTER //
// ../../../../resources/assets/js/app/plugins/toasts/Toast.vue